function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsEdit } from '@deephaven/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class MarkdownContainer extends PureComponent {
  render() {
    var _this$props = this.props,
      isEditing = _this$props.isEditing,
      children = _this$props.children,
      onDoubleClick = _this$props.onDoubleClick;
    return /*#__PURE__*/_jsxs("div", {
      className: "markdown-editor-container h-100 w-100",
      onDoubleClick: onDoubleClick,
      children: [/*#__PURE__*/_jsx("div", {
        className: classNames('text-muted', 'edit-hint', {
          viewing: isEditing === undefined || !isEditing
        }),
        children: /*#__PURE__*/_jsxs("span", {
          children: ["double-click to edit ", /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsEdit
          })]
        })
      }), children]
    });
  }
}
_defineProperty(MarkdownContainer, "defaultProps", {
  isEditing: false
});
//# sourceMappingURL=MarkdownContainer.js.map